import * as React from "react";
const SvgKeyboardArrowInsert = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M18.277 4 20 5.723 8.185 17.54h10.584V20H4V5.23h2.462v10.585z"
    />
  </svg>
);
export default SvgKeyboardArrowInsert;
